const clientInfoTypes = {
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  LEGAL_NOTICE: 'LEGAL_NOTICE'
};

export {
  clientInfoTypes
};
